import React from "react";

const NotFound = () => {
  return <div className="notfound">Not found</div>;
};

export default NotFound;
